module.exports = "<header>\r\n  <a href=\"#\" class=\"logo\" (click)=\"reload()\">verkerkselect.solucionesalrespecto</a>\r\n\r\n  <a href=\"#\" class=\"menuButton\" (click)=\"openLocale()\" style=\"display: none\">Menu</a>\r\n  <ul *ngIf=\"locale\" class=\"localeMenu\">\r\n    <li class=\"localeTitle\">{{'header.localeTitle' | translate }}</li>\r\n    <li *ngFor=\"let locale of localeList\" (click)=\"changeLocale(locale.code)\">{{locale.name}}</li>\r\n  </ul>\r\n</header>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = 345
// module chunks = 1